import styled from 'styled-components'

export const ImageWrapper = styled.div`
    background-color: ${(props) => props.theme.color.g100};
    height: 370px;
    display: flex;
    flex-direction: column;
    justify-content: end;
    align-items: center;
    margin-bottom: 20px;
    transition: background-color 0.3s ease-in-out;
`

export const Wrapper = styled.div`
    cursor: pointer;

    &:hover ${ImageWrapper}, &:focus ${ImageWrapper} {
        background-color: ${(props) => props.theme.color.g200};
    }
`

export const Title = styled.h3`
    ${(props) => props.theme.typo.bodyL};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.p500};
    margin-bottom: 5px;
`

export const Subtitle = styled.p`
    ${(props) => props.theme.typo.bodyM};
    ${(props) => props.theme.fontWeight.medium};
    color: ${(props) => props.theme.color.g600};
`
